<template>
	<div class="row">
		<div class="col-12 text-center" v-if="mini">
			<span><i class="fa fa-cog fa-spin"></i></span>
		</div>
		<div class="col-12 text-center" v-else>
			<h1><i class="fas fa-cog fa-spin"></i></h1>
			<h5>{{title ? title : 'Betöltés'}}...</h5>
		</div>
	</div>
</template>

<script>
export default {
	props: { title: String, mini: Boolean},
};
</script>
